import * as config from "config-api";

export const TRENDING_CACHE_TIME = 5; // cache time in minutes
export const GRAPHQL_URL = config.getString("Client.contentApi.baseGraphqlURL");
export const MODE_CAML = "CaML";
